import React from 'react'
import cs from 'classnames'

import SvgIcon from 'src/components/SvgIcon'
import iphone from '../../../assets/Iphone1.png'
import iphoneFr from '../../../assets/Iphone1_FR.png'
import intlMessagesApp from 'src/modules/App/translations'

import commonStyles from '../../common.module.less'
import styles from './styles.module.less'
import { FormattedHTMLMessage, FormattedMessage, injectIntl } from 'react-intl'

import toReactComponent from 'svgr.macro'

const TapIconDown = toReactComponent('../../../assets/TapIconDown.svg')

export default injectIntl(props => {
  const screenshot = props.language === 'fr' ? iphoneFr : iphone
  return (
    <section className={cs(commonStyles.container)}>
      <section className={commonStyles.top}>
        <TapIconDown className={styles.iconDownStep} />
        <img
          src={screenshot}
          className={styles.bgStep}
          alt={props.intl.formatMessage(intlMessagesApp.altScreenshot)}
        />
        <div className={styles.overlayStep} />
      </section>
      <section className={commonStyles.bottom}>
        <div className={commonStyles.content}>
          <header>
            <SvgIcon
              className={commonStyles.iconFabStep}
              size='xlg'
              type='LockIcon'
              style={{ margin: '5px auto' }}
            />
            <h2>
              <FormattedMessage id='app.lock.screen.header.privacy' defaultMessage='Privacy' />
            </h2>
            <p>
              <FormattedMessage
                id='app.lock.screen.guidedAccess'
                defaultMessage='Turn on Guided access'
              />
            </p>
          </header>
          <div className={commonStyles.scrollable}>
            <p>
              <FormattedHTMLMessage
                id='app.lock.ios.screen1.p1'
                defaultMessage='Go to Settings > General > Accessibility > <b>Guided Access</b>.'
              />
            </p>
            <div className={commonStyles.line} />
            <p>
              <FormattedMessage
                id='app.lock.screen.guidedAccess'
                defaultMessage='Turn on Guided access'
              />
            </p>
          </div>
        </div>
      </section>
    </section>
  )
})
